export const REQUEST_ABSENCE_OVERTIME = '/request/';
export const REQUEST_UPDATE_ABSENCE_OVERTIME = id => `/request/${id}/`;
export const REQUEST_PAST_ABSENCE_OVERTIME = date => `/request/past/${date}/`;
